import { useState } from 'react';
import dynamic from 'next/dynamic';
import { Link, Box } from '@thebouqs/ui';

import CartDrawer from '@/components/Product/CartDrawer';
import useUser from '@/hooks/useUser';
import { MenuLinkProps } from './MenuLink.d';

const SubMenu = dynamic(() => import('../SubMenu'), { ssr: false });

const MenuLink = ({
  linkContent,
  linkChildren,
  linkPath,
  topLinkIndex,
  isDesktop,
}: MenuLinkProps): JSX.Element => {
  const { is_subscriber, subscription_activation_used } = useUser();
  const [cartData, setCartData] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const eligibleForSubs =
    !subscription_activation_used && (is_subscriber ?? false) === false;

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    if (isDrawerOpen) setCartData(null);
  };

  if (isDesktop && linkChildren) {
    return (
      <SubMenu
        topLinkContent={linkContent}
        topLinkIndex={topLinkIndex}
        topLinkPath={linkPath}
        subMenuLinks={linkChildren}
      />
    );
  } else {
    return (
      <>
        {linkPath.includes('/cart') ? (
          <Box _hover={{ cursor: 'pointer' }} className="cart-icon">
            {linkContent}
          </Box>
        ) : (
          <Link href={linkPath} fontWeight="semibold">
            {linkContent}
          </Link>
        )}
        <CartDrawer
          isDrawerOpen={isDrawerOpen}
          cartProducts={cartData}
          toggleDrawer={toggleDrawer}
          eligibleForSubs={eligibleForSubs}
        />
      </>
    );
  }
};

export default MenuLink;
